/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SegnalazioneAccountRowDTO { 
    id?: string;
    riferimento?: string;
    stato?: SegnalazioneAccountRowDTOStatoEnum;
    esito?: SegnalazioneAccountRowDTOEsitoEnum;
    provider?: SegnalazioneAccountRowDTOProviderEnum;
    created_at?: string;
    segnalante_nome?: string;
    segnalante_cognome?: string;
    account_snapshot?: string;
    user_segnalato_id?: string;
}
export enum SegnalazioneAccountRowDTOStatoEnum {
    APERTA = 'APERTA',
    IN_LAVORAZIONE = 'IN_LAVORAZIONE',
    CHIUSA = 'CHIUSA'
};
export enum SegnalazioneAccountRowDTOEsitoEnum {
    ACCOUNT_ABUSIVO_ANONIMIZZATO = 'ACCOUNT_ABUSIVO_ANONIMIZZATO',
    NESSUN_ABUSO = 'NESSUN_ABUSO',
    RITIRATA_DAL_SEGNALANTE = 'RITIRATA_DAL_SEGNALANTE',
    ALTRO = 'ALTRO'
};
export enum SegnalazioneAccountRowDTOProviderEnum {
    SPID = 'SPID',
    CIE = 'CIE'
};



